import { ICoreContext } from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { getAttributeStringOrDefault } from '../../../shared-utils/attributes';
import { getBrandSchemesByIdsAsync } from '../../../actions/get-brand-schemes.action';

export interface IBrandScheme {
    id: string;
    name?: string;
    imageUrl?: string;
}

export const useBrandSchemes = (context: ICoreContext, attributes: AttributeValue[] | undefined) => {
    const [brandSchemes, setBrandSchemes] = React.useState<IBrandScheme[] | undefined>(undefined);

    React.useEffect(() => {
        if (!attributes) {
            return;
        }

        const brandSchemesAttrValue = getAttributeStringOrDefault(context.request.locale, attributes, 'specialBadges', '');

        if (!brandSchemesAttrValue) {
            return;
        }

        const newBrandSchemes: IBrandScheme[] = brandSchemesAttrValue.split('|').map(id => ({ id }));

        void getBrandSchemesByIdsAsync({ callerContext: context.actionContext }, brandSchemesAttrValue.split('|'))
            .then(result => {
                setBrandSchemes(newBrandSchemes.map(x => {
                    const brandScheme = result.find(y => y.BrandSchemeId === x.id);
                    return {
                        id: x.id,
                        name: brandScheme?.BrandSchemeName,
                        imageUrl: brandScheme?.ImageUrl
                    };
                }));
            })
            .catch((error) => {
                console.error(`Could not get brand schemes by ids`, error);
            });
    }, []);

    return [brandSchemes];
};